<template>
  <modal
    v-if="showModal"
    @close="closeModal"
    class="shoppable-modal"
  >
    <template #modal-header="{ close }">
      <div class="title">Browse Catalogs</div>
      <button
        class="modal-close tb-btn tb-btn-text sm low-em"
        data-test="shoppableModal-close"
        @click="close"
        data-entity="producer-shoppable-closeFanaticsModal"
      >
        <span class="icon icon-cross" />
      </button>
    </template>

    <template slot="modal-body">
      <div class="tabs-component flex-column flex-grow">
        <div class="tabs-header flex">
          <button
            class="tab-title"
            v-for="tab in tabs"
            :key="tab.value"
            :class="{ active: tab.value === activeTab.value }"
            :data-test="`shoppableModal-${tab.title}`"
            @click="activeTab = tab"
          >
            {{ tab.title }}
          </button>
        </div>

        <div class="tab-body flex-grow">
          <keep-alive>
            <fanatics-catalog
              :is="activeTab.component"
              data-test="shoppableModal-fanaticsCatalog"
              @selected="handleSelectedItems(activeTab.value, $event)"
            />
          </keep-alive>
        </div>
      </div>


    </template>

    <template #modal-footer>
      <div class="flex items-center content-end">
        <p
          v-if="selectedCollection"
          class="flex-grow margin-bottom-none margin-right-md text-left"
        >
          Saving to collection: {{ selectedCollectionData.name }}
        </p>
        <p
          v-if="totalSelectedItems > 0"
          class="margin-bottom-none margin-right-md text-primary"
        >{{ totalSelectedItems }} item(s) saved</p>
        <button
          class="tb-btn tb-btn-contained medium-em"
          data-entity="producer-shoppable-done"
          data-test="shoppableModal-doneButton"
          @click="done"
        >
          Done
        </button>
      </div>
    </template>
  </modal>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

import Modal from '@/js/components/modal/Modal.vue';
import FanaticsCatalog from '@/js/components/shoppable/FanaticsCatalog.vue';
import AmazonCatalog from '@/js/components/shoppable/AmazonCatalog.vue';

export default {
  name: 'ShoppableModal',
  props: {
    value: {
      type: Boolean,
      required: true,
    },
  },

  components: {
    Modal,
    FanaticsCatalog,
  },

  data() {
    return {
      selectedItemsByTab: {},
      activeTab: null, // default set in created
    };
  },

  computed: {
    ...mapState('shoppable', [
      'selectedCollection',
    ]),
    ...mapGetters('shoppable', [
      'selectedCollectionData',
    ]),

    ...mapGetters([
      'hasShoppableAmazon',
    ]),

    showModal: {
      get() {
        return this.value;
      },
      set(v) {
        if (!v) {
          this.$emit('close', v);
        }
      },
    },

    tabs() {
      const tabsList = [
        {
          title: 'Fanatics',
          value: 'fanatics',
          component: FanaticsCatalog,
        },
      ];

      if (this.hasShoppableAmazon) {
        tabsList.push({
          title: 'Amazon',
          value: 'amazon',
          component: AmazonCatalog,
        });
      }

      return tabsList;
    },

    totalSelectedItems() {
      return this.selectedItemsByTab[this.activeTab.value] || 0;
    },
  },

  created() {
    // TODO: should this be the default each time the modal is opened or should it remember the last tab?
    // this way will allow it to remember the last tab
    // use watch to reset activeTab to first tab when modal is closed
    [this.activeTab] = this.tabs;
  },

  methods: {
    closeModal() {
      this.showModal = false;
    },
    done() {
      this.selectedItemsByTab = [];
      this.closeModal();
    },
    handleSelectedItems(tab, items) {
      this.$set(this.selectedItemsByTab, tab, items);
    },
  },
};
</script>

<style lang="scss">
.shoppable-modal {
  // specificity overrides
  .modal-body {
    min-height: 350px;
    display: flex;
    flex-direction: column;
  }
  .filter-bar {
    padding: 0;
  }
}
</style>
